import { cx } from '@libs/classnames';
import { Badge } from '@ui/components/Badge';
import { LinearChart } from '@ui/components/LinearChart/LinearChart';

import { ChartPoint } from '@features/shared/api/typings';

import styles from './PlayerEloStatPreview.module.css';

type EloStatProps = {
  title: string;
  gameCount?: number;
  rank?: number;
  delta?: number;
  points?: ChartPoint[];
  showBorder?: boolean;
};
export function PlayerEloStatPreview({
  title,
  gameCount,
  rank,
  delta,
  points,
  showBorder,
}: EloStatProps) {
  return (
    <div className={cx(styles.eloStat, { [styles.bordered]: showBorder })}>
      <div className={styles.rankLabel}>
        <div className={styles.rankTitle}>{title}</div>
        {gameCount !== undefined && (
          <Badge className={styles.gameCount} size="xs">
            {gameCount}
          </Badge>
        )}
      </div>
      <div className={styles.rank}>{rank}</div>
      {delta !== undefined && (
        <div
          className={cx(styles.delta, {
            [styles.positive]: delta > 0,
          })}
        >
          {delta > 0 ? '+' : ''}
          {delta}
        </div>
      )}

      {points && points.length > 0 && <LinearChart className={styles.chart} points={points} />}
    </div>
  );
}
